var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiveUsoComercialEmbalaje(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0089CF;}\n\t.st1{fill:none;stroke:#296EB7;stroke-width:0.65;stroke-miterlimit:10;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9.8,
    className: "st0",
    width: 7.7,
    height: 31.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 9.8,
    className: "st0",
    width: 7.7,
    height: 31.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 9.8,
    className: "st0",
    width: 7.7,
    height: 31.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 9.8,
    className: "st0",
    width: 7.7,
    height: 31.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.9,9.8 30.7,9.8 19.5,25 11.1,25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.4,9.8 78.8,9.8 55.5,41.3 55.5,27.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.8,26.1 11.1,26.1 22.2,41.3 30.7,41.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "108.4,7.9 103.6,13.6 112.5,25 121,25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "112.2,26.1 121,26.1 108.4,42.4 103.2,37.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.2,
    y: 9.8,
    className: "st0",
    width: 12.1,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.2,
    y: 22,
    className: "st0",
    width: 7.3,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.2,
    y: 34.5,
    className: "st0",
    width: 12.1,
    height: 6.8
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.9,21.6c0.6,0.6,1.5,0.9,2.6,0.9c1.1,0,1.9-0.3,2.6-0.9c0.6-0.6,0.9-1.5,0.9-2.6v-8.1h2.8V19 c0,1.2-0.3,2.2-0.8,3.1c-0.5,0.9-1.2,1.6-2.2,2c-0.9,0.5-2.1,0.7-3.3,0.7c-1.3,0-2.4-0.2-3.4-0.7c-1-0.5-1.7-1.2-2.2-2 c-0.5-0.9-0.8-1.9-0.8-3.1v-8.1h2.8V19C139.9,20.1,140.2,21,140.9,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.5,13.4c-0.8-0.2-1.5-0.4-2.1-0.4c-0.7,0-1.2,0.1-1.6,0.4c-0.4,0.2-0.6,0.6-0.6,1c0,0.4,0.1,0.7,0.4,1 c0.3,0.3,0.6,0.5,1,0.6c0.4,0.2,1,0.3,1.7,0.5c1,0.3,1.8,0.6,2.4,0.8c0.6,0.3,1.2,0.7,1.6,1.2c0.4,0.5,0.7,1.2,0.7,2.1 c0,0.8-0.2,1.6-0.7,2.2c-0.5,0.6-1.1,1.1-2,1.4c-0.8,0.3-1.8,0.5-2.9,0.5c-1.1,0-2.2-0.2-3.3-0.6c-1.1-0.4-2-0.9-2.8-1.6l1.2-2.2 c0.7,0.6,1.6,1.1,2.5,1.5c0.9,0.4,1.8,0.6,2.5,0.6c0.8,0,1.4-0.1,1.8-0.4c0.4-0.3,0.7-0.7,0.7-1.2c0-0.4-0.1-0.7-0.4-1 c-0.3-0.3-0.6-0.5-1-0.6s-1-0.3-1.7-0.5c-1-0.3-1.8-0.5-2.4-0.8c-0.6-0.3-1.2-0.7-1.6-1.2c-0.4-0.5-0.7-1.2-0.7-2.1 c0-0.8,0.2-1.5,0.7-2.1c0.4-0.6,1.1-1.1,1.9-1.4c0.8-0.3,1.8-0.5,2.8-0.5c0.9,0,1.9,0.1,2.8,0.4c0.9,0.3,1.7,0.6,2.4,1.1l-1.1,2.3 C161,14,160.2,13.7,159.5,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.7,11.6c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1,2.3,1,3.6s-0.3,2.5-1,3.6c-0.7,1.1-1.6,1.9-2.8,2.6 c-1.2,0.6-2.5,0.9-3.9,0.9c-1.4,0-2.7-0.3-3.9-0.9c-1.2-0.6-2.1-1.5-2.8-2.6s-1-2.3-1-3.6s0.3-2.5,1-3.6s1.6-1.9,2.8-2.5 c1.2-0.6,2.5-0.9,3.9-0.9C173.3,10.7,174.6,11,175.7,11.6z M169.4,13.7c-0.8,0.4-1.4,1-1.8,1.7s-0.7,1.5-0.7,2.4s0.2,1.7,0.7,2.4 c0.4,0.7,1,1.3,1.8,1.7c0.8,0.4,1.6,0.6,2.5,0.6c0.9,0,1.7-0.2,2.4-0.6c0.7-0.4,1.3-1,1.8-1.7c0.4-0.7,0.7-1.5,0.7-2.4 s-0.2-1.7-0.7-2.4s-1-1.3-1.8-1.7c-0.7-0.4-1.6-0.6-2.4-0.6C171,13.1,170.2,13.3,169.4,13.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.8,13.6c-0.7-0.3-1.4-0.5-2.1-0.5c-0.9,0-1.7,0.2-2.5,0.6s-1.3,1-1.8,1.7c-0.4,0.7-0.6,1.5-0.6,2.4 c0,0.9,0.2,1.6,0.6,2.4c0.4,0.7,1,1.3,1.8,1.7s1.6,0.6,2.5,0.6c0.7,0,1.4-0.1,2.1-0.4c0.7-0.3,1.3-0.7,1.9-1.2l1.6,1.7 c-0.8,0.7-1.6,1.3-2.6,1.7c-1,0.4-2,0.6-3.1,0.6c-1.4,0-2.7-0.3-3.8-0.9c-1.2-0.6-2.1-1.5-2.7-2.6s-1-2.3-1-3.6s0.3-2.5,1-3.6 s1.6-1.9,2.8-2.5c1.2-0.6,2.5-0.9,3.9-0.9c1,0,2,0.2,3,0.6c1,0.4,1.8,0.9,2.5,1.6l-1.6,1.9C196.1,14.3,195.5,13.9,194.8,13.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.3,11.6c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1,2.3,1,3.6s-0.3,2.5-1,3.6c-0.7,1.1-1.6,1.9-2.8,2.6 c-1.2,0.6-2.5,0.9-3.9,0.9s-2.7-0.3-3.9-0.9c-1.2-0.6-2.1-1.5-2.8-2.6s-1-2.3-1-3.6s0.3-2.5,1-3.6s1.6-1.9,2.8-2.5 c1.2-0.6,2.5-0.9,3.9-0.9S209.2,11,210.3,11.6z M204,13.7c-0.8,0.4-1.4,1-1.8,1.7s-0.7,1.5-0.7,2.4s0.2,1.7,0.7,2.4 c0.4,0.7,1,1.3,1.8,1.7c0.8,0.4,1.6,0.6,2.4,0.6c0.9,0,1.7-0.2,2.4-0.6c0.7-0.4,1.3-1,1.8-1.7c0.4-0.7,0.7-1.5,0.7-2.4 s-0.2-1.7-0.7-2.4c-0.4-0.7-1-1.3-1.8-1.7c-0.7-0.4-1.6-0.6-2.4-0.6C205.6,13.1,204.8,13.3,204,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.2,10.9h3.2l4.8,8.9l4.8-8.9h3.2v13.8h-2.5v-9.9l-4.5,8.5h-1.8l-4.5-8.5v9.9h-2.5V10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.2,10.9h10.6v2.3H238v3.4h7v2.3h-7v3.5h8.1v2.3h-10.9V10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.6,24.7l-2.5-4.1c-0.1,0-0.3,0-0.5,0h-3.3v4.1h-2.8V10.9h6c1.9,0,3.3,0.4,4.3,1.2c1,0.8,1.5,2,1.5,3.5 c0,1.1-0.2,2-0.7,2.8c-0.5,0.8-1.2,1.3-2.1,1.7l3.2,4.6H257.6z M251.3,18.3h3.3c1,0,1.8-0.2,2.4-0.6c0.6-0.4,0.8-1.1,0.8-1.9 c0-0.8-0.3-1.5-0.8-1.9c-0.6-0.4-1.4-0.6-2.4-0.6h-3.3V18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.7,13.6c-0.7-0.3-1.4-0.5-2.1-0.5c-0.9,0-1.7,0.2-2.5,0.6s-1.3,1-1.8,1.7c-0.4,0.7-0.6,1.5-0.6,2.4 c0,0.9,0.2,1.6,0.6,2.4c0.4,0.7,1,1.3,1.8,1.7s1.6,0.6,2.5,0.6c0.7,0,1.4-0.1,2.1-0.4c0.7-0.3,1.3-0.7,1.9-1.2l1.6,1.7 c-0.8,0.7-1.6,1.3-2.6,1.7s-2,0.6-3.1,0.6c-1.4,0-2.7-0.3-3.8-0.9c-1.2-0.6-2.1-1.5-2.7-2.6c-0.7-1.1-1-2.3-1-3.6s0.3-2.5,1-3.6 c0.7-1.1,1.6-1.9,2.8-2.5s2.5-0.9,3.9-0.9c1,0,2,0.2,3,0.6c1,0.4,1.8,0.9,2.5,1.6l-1.6,1.9C273,14.3,272.4,13.9,271.7,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,10.9h2.8v13.8H277V10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.7,24.7l-1.3-2.9h-7.1l-1.3,2.9h-2.9l6.3-13.8h2.9l6.3,13.8H293.7z M286.3,19.5h5.1l-2.5-5.8L286.3,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298,10.9h2.8v11.4h6.2v2.4h-9V10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.3,22.4c0.3,0.2,0.4,0.6,0.4,1c0,0.2,0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.6l-1.3,2.4h-1.3l0.9-2.3 c-0.4-0.3-0.6-0.6-0.6-1.1c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4C309.7,22.1,310.1,22.2,310.3,22.4z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.4,30.1H148v2.3h-7.8v3.4h7v2.3h-7v3.5h8.1v2.3h-10.9V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.7,30.1h3.2l4.8,8.9l4.8-8.9h3.2v13.8H164V34l-4.5,8.5h-1.8l-4.5-8.5v9.9h-2.5V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.8,31c0.9,0.6,1.3,1.5,1.3,2.5c0,0.8-0.2,1.4-0.7,2c-0.4,0.5-1.1,0.9-1.9,1.1c1,0.2,1.7,0.6,2.3,1.2 c0.5,0.6,0.8,1.4,0.8,2.3c0,1.2-0.5,2.1-1.4,2.8c-1,0.7-2.3,1-3.9,1h-6.6V30.1h6.4C177.7,30.1,178.9,30.4,179.8,31z M177.7,35.3 c0.4-0.3,0.6-0.7,0.6-1.3c0-0.5-0.2-0.9-0.6-1.2c-0.4-0.3-1-0.4-1.7-0.4h-3.5v3.3h3.5C176.7,35.7,177.3,35.6,177.7,35.3z  M178.1,41.1c0.5-0.3,0.7-0.8,0.7-1.4c0-0.6-0.2-1-0.7-1.3s-1.2-0.5-2.1-0.5h-3.5v3.6h3.5C176.9,41.6,177.6,41.5,178.1,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.7,43.9l-1.3-2.9h-7.1l-1.3,2.9h-2.9l6.3-13.8h2.9l6.3,13.8H194.7z M187.3,38.7h5.1l-2.5-5.8L187.3,38.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199,30.1h2.8v11.4h6.2v2.4h-9V30.1z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.5,43.9l-1.3-2.9h-7.1l-1.3,2.9H208l6.3-13.8h2.9l6.3,13.8H220.5z M213.2,38.7h5.1l-2.5-5.8L213.2,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.9,42.8c-0.8,0.8-2,1.2-3.4,1.2c-1.8,0-3.3-0.7-4.5-2.1l1.3-2c0.5,0.5,1,0.9,1.5,1.1s1.1,0.4,1.5,0.4 c0.6,0,1.1-0.2,1.4-0.5c0.3-0.3,0.5-0.8,0.5-1.5v-7h-5v-2.3h7.8v9.5C232.1,41,231.7,42,230.9,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235,30.1h10.6v2.3h-7.8v3.4h7v2.3h-7v3.5h8.1v2.3H235V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.1,32.6c-0.8-0.2-1.5-0.4-2.1-0.4c-0.7,0-1.2,0.1-1.6,0.4s-0.6,0.6-0.6,1c0,0.4,0.1,0.7,0.4,1 s0.6,0.5,1,0.6s1,0.3,1.7,0.5c1,0.3,1.8,0.6,2.4,0.8c0.6,0.3,1.2,0.7,1.6,1.2s0.7,1.2,0.7,2.1c0,0.8-0.2,1.6-0.7,2.2 c-0.5,0.6-1.1,1.1-2,1.4s-1.8,0.5-2.9,0.5c-1.1,0-2.2-0.2-3.3-0.6c-1.1-0.4-2-0.9-2.8-1.6l1.2-2.2c0.7,0.6,1.6,1.1,2.5,1.5 s1.8,0.6,2.5,0.6c0.8,0,1.4-0.1,1.8-0.4c0.4-0.3,0.7-0.7,0.7-1.2c0-0.4-0.1-0.7-0.4-1c-0.3-0.3-0.6-0.5-1-0.6 c-0.4-0.2-1-0.3-1.7-0.5c-1-0.3-1.8-0.5-2.4-0.8c-0.6-0.3-1.2-0.7-1.6-1.2c-0.4-0.5-0.7-1.2-0.7-2.1c0-0.8,0.2-1.5,0.7-2.1 c0.4-0.6,1.1-1.1,1.9-1.4s1.8-0.5,2.8-0.5c0.9,0,1.9,0.1,2.8,0.4c0.9,0.3,1.7,0.6,2.5,1.1l-1.1,2.3 C256.6,33.2,255.9,32.9,255.1,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.2,30.1l-5.3,9.3v4.5h-2.8v-4.4l-5.4-9.4h2.8l3.9,6.5l3.9-6.5H277.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293,31c1.1,0.6,2,1.4,2.7,2.5c0.6,1.1,1,2.2,1,3.6s-0.3,2.5-1,3.6c-0.7,1-1.6,1.9-2.7,2.5 c-1.2,0.6-2.5,0.9-3.9,0.9h-5.9V30.1h6C290.6,30.1,291.9,30.4,293,31z M291.6,41c0.7-0.4,1.3-0.9,1.7-1.6s0.6-1.5,0.6-2.4 c0-0.9-0.2-1.7-0.6-2.4c-0.4-0.7-1-1.2-1.7-1.6c-0.7-0.4-1.5-0.6-2.4-0.6h-3.2v9.1h3.3C290.1,41.6,290.9,41.4,291.6,41z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.7,30.8c1.2,0.6,2.1,1.5,2.8,2.5s1,2.3,1,3.6s-0.3,2.5-1,3.6c-0.7,1.1-1.6,1.9-2.8,2.6s-2.5,0.9-3.9,0.9 c-1.4,0-2.7-0.3-3.9-0.9s-2.1-1.5-2.8-2.6c-0.7-1.1-1-2.3-1-3.6s0.3-2.5,1-3.6c0.7-1.1,1.6-1.9,2.8-2.5s2.5-0.9,3.9-0.9 C306.2,29.9,307.5,30.2,308.7,30.8z M302.3,32.9c-0.8,0.4-1.4,1-1.8,1.7c-0.4,0.7-0.7,1.5-0.7,2.4s0.2,1.7,0.7,2.4 c0.4,0.7,1,1.3,1.8,1.7c0.8,0.4,1.6,0.6,2.5,0.6c0.9,0,1.7-0.2,2.4-0.6s1.3-1,1.8-1.7c0.4-0.7,0.7-1.5,0.7-2.4s-0.2-1.7-0.7-2.4 c-0.4-0.7-1-1.3-1.8-1.7c-0.7-0.4-1.6-0.6-2.4-0.6C303.9,32.3,303.1,32.5,302.3,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.5,30.1h3.2l4.8,8.9l4.8-8.9h3.2v13.8h-2.5V34l-4.5,8.5h-1.8L317,34v9.9h-2.5V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.5,30.1h10.6v2.3h-7.8v3.4h7v2.3h-7v3.5h8.1v2.3h-10.9V30.1z M339.8,26l2.6,1l-2.6,2l-2.1-0.2L339.8,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.6,32.6c-0.8-0.2-1.5-0.4-2.1-0.4c-0.7,0-1.2,0.1-1.6,0.4s-0.6,0.6-0.6,1c0,0.4,0.1,0.7,0.4,1 s0.6,0.5,1,0.6s1,0.3,1.7,0.5c1,0.3,1.8,0.6,2.4,0.8c0.6,0.3,1.2,0.7,1.6,1.2s0.7,1.2,0.7,2.1c0,0.8-0.2,1.6-0.7,2.2 c-0.5,0.6-1.1,1.1-2,1.4s-1.8,0.5-2.9,0.5c-1.1,0-2.2-0.2-3.3-0.6c-1.1-0.4-2-0.9-2.8-1.6l1.2-2.2c0.7,0.6,1.6,1.1,2.5,1.5 s1.8,0.6,2.5,0.6c0.8,0,1.4-0.1,1.8-0.4c0.4-0.3,0.7-0.7,0.7-1.2c0-0.4-0.1-0.7-0.4-1c-0.3-0.3-0.6-0.5-1-0.6 c-0.4-0.2-1-0.3-1.7-0.5c-1-0.3-1.8-0.5-2.4-0.8c-0.6-0.3-1.2-0.7-1.6-1.2c-0.4-0.5-0.7-1.2-0.7-2.1c0-0.8,0.2-1.5,0.7-2.1 c0.4-0.6,1.1-1.1,1.9-1.4s1.8-0.5,2.8-0.5c0.9,0,1.9,0.1,2.8,0.4c0.9,0.3,1.7,0.6,2.5,1.1l-1.1,2.3 C355.2,33.2,354.4,32.9,353.6,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.8,30.1h11.8v2.3h-4.5v11.4h-2.8V32.4h-4.5V30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.2,30.1h2.8v13.8h-2.8V30.1z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.6,32.8c-0.7-0.3-1.4-0.5-2.1-0.5c-0.9,0-1.7,0.2-2.5,0.6c-0.7,0.4-1.3,1-1.8,1.7 c-0.4,0.7-0.6,1.5-0.6,2.4s0.2,1.6,0.6,2.4c0.4,0.7,1,1.3,1.8,1.7s1.6,0.6,2.5,0.6c0.7,0,1.4-0.1,2.1-0.4c0.7-0.3,1.3-0.7,1.9-1.2 l1.6,1.7c-0.8,0.7-1.6,1.3-2.6,1.7c-1,0.4-2,0.6-3.1,0.6c-1.4,0-2.7-0.3-3.8-0.9c-1.2-0.6-2.1-1.5-2.7-2.6c-0.7-1.1-1-2.3-1-3.6 s0.3-2.5,1-3.6s1.6-1.9,2.8-2.5c1.2-0.6,2.5-0.9,3.9-0.9c1,0,2,0.2,3,0.6c1,0.4,1.8,0.9,2.5,1.6l-1.6,1.9 C386.9,33.5,386.3,33.1,385.6,32.8z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401.1,30.8c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1,2.3,1,3.6s-0.3,2.5-1,3.6c-0.7,1.1-1.6,1.9-2.8,2.6 c-1.2,0.6-2.5,0.9-3.9,0.9s-2.7-0.3-3.9-0.9c-1.2-0.6-2.1-1.5-2.8-2.6c-0.7-1.1-1-2.3-1-3.6s0.3-2.5,1-3.6s1.6-1.9,2.8-2.5 c1.2-0.6,2.5-0.9,3.9-0.9S400,30.2,401.1,30.8z M394.8,32.9c-0.8,0.4-1.4,1-1.8,1.7c-0.4,0.7-0.7,1.5-0.7,2.4s0.2,1.7,0.7,2.4 c0.4,0.7,1,1.3,1.8,1.7c0.8,0.4,1.6,0.6,2.5,0.6c0.9,0,1.7-0.2,2.4-0.6s1.3-1,1.8-1.7c0.4-0.7,0.7-1.5,0.7-2.4s-0.2-1.7-0.7-2.4 c-0.4-0.7-1-1.3-1.8-1.7c-0.7-0.4-1.6-0.6-2.4-0.6C396.4,32.3,395.6,32.5,394.8,32.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiveUsoComercialEmbalaje);
export default __webpack_public_path__ + "static/media/kive-uso-comercial-embalaje.82875271d368851f7f52466457e8f952.svg";
export { ForwardRef as ReactComponent };